<footer class="bg-[#003049] text-white body-font" *ngIf="canShow()">
  <div class="container px-5 py-6 mx-auto flex flex-col sm:flex-row items-center justify-between">
    <a href="/" class="flex items-center mb-4 sm:mb-0">
      <img src="/assets/logo_white.svg" alt="Logo" class="h-10">
    </a>
    <p class="text-sm text-[#B8B8B8] text-center sm:text-left m-0" style="margin: 0!important;">
      © 2025 Futuro ACS. Todos os direitos reservados.
    </p>
  </div>
</footer>
